'use strict';
import AllIWantDataCache from 'App/helpers/allIWantDataCache';

angular.module('upResources').factory('ContactCategory', [
	'$resource',
	'$q',
	'URL',
	'API',
	'AccountCategoryAttributes',
	'CacheService',
	'ParseGeneric',
	'AppService',
	'ResourceHelper',
	function ContactCategory(
		$resource,
		$q,
		URL,
		API,
		AccountCategoryAttributes,
		CacheService,
		ParseGeneric,
		AppService,
		ResourceHelper
	) {
		var CA = AccountCategoryAttributes();
		var Attribute = CA.attr;
		var Keys = CA.keys;

		var helper = new ResourceHelper();

		helper.setDefaults({
			eventPrefix: 'category',
			createSuccessBody: 'saved.category',
			updateSuccessBody: 'updated.category',
			deleteSucccessBody: 'deleted.category',
			createErrorBody: 'saveError.category',
			updateErrorBody: 'saveError.category',
			deleteErrorBody: 'deleteError.category'
		});

		var Model = {
			customer: function (customer) {
				var instance = {};
				var Category = null;
				var Cache = CacheService.getCache(CacheService.cacheTypes.CONTACTCATEGORY);
				Category = $resource(
					URL + API + customer + '/contactcategories/:id',
					{},
					{
						find: {
							method: 'GET',
							isArray: false,
							transformResponse: ParseGeneric('ParseCategory', { isArray: true })
						},
						get: {
							method: 'GET',
							isArray: false,
							transformResponse: ParseGeneric('ParseCategory', { isArray: false })
						},
						create: {
							method: 'POST',
							isArray: false,
							transformResponse: ParseGeneric('ParseCategory', { isArray: false })
						},
						update: {
							method: 'PUT',
							isArray: false,
							transformResponse: ParseGeneric('ParseCategory', { isArray: false })
						},
						merge: {
							method: 'POST',
							isArray: false,
							url: URL + API + customer + '/contactcategories/merge',
							transformResponse: ParseGeneric('ParseCategory', { isArray: false })
						}
					}
				);

				instance.find = function (filter, options) {
					var defered = $q.defer();
					var params = angular.extend(filter, options);

					Category.find(params, function (response) {
						defered.resolve(response);
					});

					return defered.promise;
				};

				instance.get = function (id) {
					if (!id) return $q.reject('no category id');

					return Category.get({ id: id }).$promise;
				};

				instance.save = function (category, options) {
					var defered = $q.defer();

					if (!category) {
						return defered.reject('No category');
					}

					if (category.id) {
						Category.update(
							{ id: category.id },
							category,
							function (response) {
								if (response.error) {
									defered.reject(response);
								}
								defered.resolve(response);
							},
							defered.reject
						);
					} else {
						Category.create(
							{},
							category,
							function (response) {
								if (response.error) {
									defered.reject(response);
								}
								defered.resolve(response);
							},
							defered.reject
						);
					}

					defered.promise
						.then(function (res) {
							var categories = AppService.getCategories('contact');
							var index = _.findIndex(categories, { id: res.data.id });

							if (index > -1) {
								categories[index] = _.cloneDeep(res.data);
							} else {
								categories.unshift(_.cloneDeep(res.data));
							}

							AppService.setCategories('contact', categories);
							AllIWantDataCache.clearData();

							helper.onSave(options, res.data, !category.id);
						})
						.catch(function (err) {
							if (_.get(err, 'data.error.errorCode') === 25) {
								helper.errorNotification(
									'default.error',
									'default.nameAlreadyInUse',
									null,
									!category.id
								);
								options = options || {};
								options.skipErrorNotification = true;
							}
							helper.onSaveError(options, !category.id);

							return $q.reject(err);
						});

					return defered.promise;
				};

				instance.getCached = function () {
					var key = 'ContactCategory';
					var cached = Cache.get(key);

					if (cached) {
						return $q.when(cached);
					} else {
						return instance.find({}).then(function (res) {
							Cache.put(key, res);
							return res;
						});
					}
				};

				instance.merge = function (mergeObj) {
					return Category.merge(mergeObj)
						.$promise.then(function (res) {
							AllIWantDataCache.clearData();
							return res;
						})
						.catch(function (err) {
							helper.onSaveError();
							return $q.reject(err);
						});
				};

				instance.delete = function (category, options) {
					return Category.delete({ id: category.id })
						.$promise.then(function (res) {
							var categories = AppService.getCategories('contact');
							categories = _.filter(categories, function (_category) {
								return _category.id !== category.id;
							});
							AppService.setCategories('contact', categories);
							AllIWantDataCache.clearData();

							helper.onDelete(options, category);
							return res;
						})
						.catch(function (err) {
							helper.onDeleteError(options);
							return $q.reject(err);
						});
				};

				return instance;
			},
			attr: Attribute,
			keys: Keys
		};

		return Model;
	}
]);
